module.exports = __webpack_public_path__ + "img/components.79ff4718.png";